import { gql } from '@apollo/client'
import { FIELD_FRAGMENT } from 'graphql/field/queries'

export const PLAN_TYPES_LIST_QUERY = gql`
  query PLAN_TYPES_LIST_QUERY($filter: PlanTypeFilterInput, $pagination: PaginationInput, $order: OrderInput) {
    planTypes(filter: $filter, pagination: $pagination, order: $order) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        description
        companyId
        allowNesting
        maximumNestedLevelsCount
        levels {
          id
          color
          description
          typeOptions {
            id
            label
          }
        }
        fields {
          ...FIELD
        }
      }
    }
  }
  ${FIELD_FRAGMENT}
`

export const PLAN_TYPES_DETAILS_QUERY = gql`
  query PLAN_TYPES_DETAILS_QUERY($filter: PlanTypeFilterInput) {
    planTypes(filter: $filter) {
      data {
        id
        description
        companyId
        color
        maximumNestedLevelsCount
        active
        allowNesting
        code
        createdAt
        updatedAt
        company {
          id
          name
        }
        levels {
          id
          color
          position
          description
          typeOptions {
            id
            label
          }
        }
        fields {
          ...FIELD
          parentField {
            id
            label
          }
        }
        objectiveOwnerObjectSecurityId
        objectiveMemberObjectSecurityId
        actionOwnerObjectSecurityId
        actionMemberObjectSecurityId
        kpiOwnerObjectSecurityId
        kpiMemberObjectSecurityId
        planOwnerObjectSecurityId
        planMemberObjectSecurityId
        objectiveOwnerObjectSecurity {
          id
          name
        }
        objectiveMemberObjectSecurity {
          id
          name
        }
        actionOwnerObjectSecurity {
          id
          name
        }
        actionMemberObjectSecurity {
          id
          name
        }
        kpiOwnerObjectSecurity {
          id
          name
        }
        kpiMemberObjectSecurity {
          id
          name
        }
        planOwnerObjectSecurity {
          id
          name
        }
        planMemberObjectSecurity {
          id
          name
        }
      }
    }
  }
  ${FIELD_FRAGMENT}
`

export const PLAN_TYPES_SELECT_QUERY = gql`
  query PLAN_TYPES_SELECT_QUERY($filter: PlanTypeFilterInput) {
    planTypes(filter: $filter) {
      data {
        id
        active
        description
        fields {
          id
          name
          options {
            id
            label
            value
          }
        }
      }
    }
  }
`
